import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
import CustomBar from "@/components/customBar";
import Upload from "@/components/upload";
import { useStore } from "@/store/index";
import { storeToRefs } from 'pinia';
import { change_avatar } from "@/api/index";

import { showToast } from 'vant/es';
import 'vant/es/toast/style/index';
export default {
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const {
      userInfo
    } = storeToRefs(store);
    const upavatar = url => {
      change_avatar({
        avatarUrl: url
      }).then(() => {
        showToast('头像修改成功');
        store.updataUserInfo();
      });
    };
    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: "个人信息"
      }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_cell, {
        title: "修改头像",
        "is-link": "",
        "value-class": "van-cell-value"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Upload), {
          modelValue: _unref(userInfo).avatar,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(userInfo).avatar = $event),
          onChange: upavatar
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_van_cell, {
        title: "账号"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_unref(userInfo).mobile), 1)]),
        _: 1
      }), _createVNode(_component_van_cell, {
        title: "昵称",
        "is-link": "",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push({
          path: 'editName',
          query: {
            nickname: _unref(userInfo).nickname
          }
        }))
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_unref(userInfo).nickname), 1)]),
        _: 1
      }), _createVNode(_component_van_cell, {
        title: "业绩"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_unref(userInfo).perform), 1)]),
        _: 1
      }), _createVNode(_component_van_cell, {
        title: "职级"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_unref(userInfo).vipLevel), 1)]),
        _: 1
      }), _createVNode(_component_van_cell, {
        title: "进货渠道商"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(_unref(userInfo).higherName), 1), _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(_unref(userInfo).higherMobile), 1)])]),
        _: 1
      }), _createVNode(_component_van_cell, {
        title: "修改登录密码",
        "is-link": "",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$router.push({
          path: 'editPwd',
          query: {
            type: 1
          }
        }))
      }), _createVNode(_component_van_cell, {
        title: "修改支付密码",
        "is-link": "",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.$router.push({
          path: 'editPwd',
          query: {
            type: 2
          }
        }))
      })])], 64);
    };
  }
};